import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  ElementRef,
  QueryList,
  ViewChild,
  ViewChildren,
  AfterViewInit
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { AppConstants } from '../../utils/appConstants.class';

import { Inspection } from '../../shared/models/index';

@Component({
    selector: 'inspection-view',
    templateUrl: './view.component.html',
    standalone: false
})
export class InspectionViewComponent implements OnInit, AfterViewInit {
  @Input() public inspection: Inspection;
  @Output() public toggleSaveInspection: EventEmitter<any> = new EventEmitter();
  @Output() public toggleCancel: EventEmitter<any> = new EventEmitter();
  @ViewChildren('plugin', { read: ElementRef }) plugins: QueryList<ElementRef>;
  @ViewChild('scroll', { read: ElementRef }) scroll: ElementRef;

  editForm: UntypedFormGroup;
  currentIndex: number = 0;

  constructor() {}

  ngOnInit(): void {
    const pluginId = sessionStorage.getItem(AppConstants.LAST_OPENED_PLUGIN_ID);
    this.currentIndex = this.inspection.plugins.sort((a, b) => a.order - b.order).findIndex((p) => p.id === pluginId);
  }

  public getEditRoute() {
    return ['/inspectionbrowser/inspections', this.inspection.id, 'edit'];
  }

  public cancel() {
    this.toggleCancel.emit();
  }

  gotoPlugin() {
    const nextElement = this.plugins.toArray()[this.currentIndex].nativeElement;
    this.scrollTo(nextElement.offsetTop);
  }

  scrollTo(value: number) {
    this.scroll.nativeElement.scrollTop = value;
  }

  ngAfterViewInit() {
    if (this.currentIndex > 0) {
      setTimeout(() => this.gotoPlugin());
      return;
    }

    this.currentIndex = 0;
  }
}
